import { FC } from "react";
import styled from "@emotion/styled";
import { MdsIcon } from "@/design-system/components/icon";
import { MdsIconKind } from "@/design-system/components/icon/types";

interface AutoOrganizeMenuItemProps {
  isSelected: boolean;
  onMouseEnter: () => void;
  onMouseLeave: () => void;
  onClick: () => void;
}

export const AutoOrganizeMenuItem: FC<AutoOrganizeMenuItemProps> = ({
  isSelected,
  onMouseEnter,
  onMouseLeave,
  onClick,
}) => {
  return (
    <Wrapper
      role="button"
      tabIndex={-1}
      isSelected={isSelected}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      onClick={onClick}
      data-auto-organize
    >
      <IconWrapper>
        <AutoOrganizeIcon kind={MdsIconKind.AutoOrganize} />
      </IconWrapper>
      <Content>
        <Title>Auto Organize</Title>
        <Subtitle>Let Mem organize into your collections</Subtitle>
      </Content>
    </Wrapper>
  );
};

const Wrapper = styled.div<{ isSelected: boolean }>(({ theme, isSelected }) => ({
  display: "flex",
  alignItems: "center",
  gap: theme.spacing.sm,
  paddingInline: theme.spacing["5"],
  paddingBlock: theme.spacing["2"],
  borderRadius: theme.borderRadius.mediumLarge,
  backgroundColor: isSelected ? theme.colors.background.menu.hover : theme.colors.transparent,
  cursor: "pointer",
  width: "100%",
}));

const IconWrapper = styled.div(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  width: 32,
  /** Yes, sorry; we can improve this in the future... */
  marginRight: -3,
  marginLeft: 3,
  color: theme.colors.icon.brand,
}));

const Content = styled.div(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing.xxs,
}));

const Title = styled.div(({ theme }) => ({
  color: theme.colors.text.primary,
  fontSize: theme.fontSizes.small,
  lineHeight: theme.lineHeights.small,
  fontWeight: theme.fontWeights.medium,
}));

const Subtitle = styled.div(({ theme }) => ({
  color: theme.colors.text.secondary,
  fontSize: theme.fontSizes.xsmall,
  lineHeight: theme.lineHeights.xsmall,
}));

const AutoOrganizeIcon = styled(MdsIcon)`
  height: 32px;
  width: 32px;

  & svg {
    font-size: 20px;
    height: 20px;
    width: 20px;

    color: ${({ theme }) => theme.colors.icon.primary} !important;
  }
`;
